import React from 'react';
import ShortId from 'shortid';

import Card from './../profile-card';
import LoadingView from './../loading';

const InfluencerGrid = ({ query, isLoading, searchPerformed, showingTrending, influencers}) => {
  const EmptyResultView = () => {
    const suggestions = [
      'Make sure that all words are spelled correctly',
      'Try different keywords',
      'Try more general keywords',
      'Try fewer keywords',
    ];
    return (
      <div className="result empty">
        <h2>No results found for &quot;{query}&quot;</h2>
        <h4>Suggestions:</h4>
        <ul>
          {suggestions.map(suggestion => <li key={ShortId.generate()}>{suggestion}</li>)}
        </ul>
      </div>
    );
  };

  return (
      <div>
        {isLoading && <LoadingView />}
        {!isLoading && influencers.length > 0 && <div className="result many">
          {showingTrending && <div className="grid-6-6"><h2>Trending Influencers</h2></div>}
          {influencers.map(influencer => (
            <div key={influencer.id} className="grid-6-6 grid-sm-6-6 grid-md-3-6 grid-lg-2-6 grid-xl-2-6">
              <Card influencer={influencer} />
            </div>
          ))
          }
        </div>
        }
        {!isLoading && searchPerformed && influencers.length === 0 && <EmptyResultView />}
      </div>
  );
};

InfluencerGrid.propTypes = {
  query: React.PropTypes.string,
  isLoading: React.PropTypes.bool.isRequired,
  searchPerformed: React.PropTypes.bool.isRequired,
  showingTrending: React.PropTypes.bool.isRequired,
  influencers: React.PropTypes.array.isRequired,
};

export default InfluencerGrid;



// WEBPACK FOOTER //
// ./src/components/influencer-grid/index.js